const URL_DYNATRACE_NON_PROD =
    'https://dok.js-cdn.dynatrace.com/jstag/183d1331750/bf63091kvt/76df17542153e781_complete.js';
const URL_DYNATRACE_PROD =
    'https://dok.js-cdn.dynatrace.com/jstag/183d1331750/bf67954ygd/da7236fd9a4c82b4_complete.js';

export function addDynatraceTagScript(isNonProd: boolean): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    script.src = isNonProd ? URL_DYNATRACE_NON_PROD : URL_DYNATRACE_PROD;

    document.head.appendChild(script);
}
